import {
  AddOnFilterColumns,
  AddOnFilterModel,
  useAddOnFilter,
  useSetAddOnFilter,
  useValidateAddOnListOrder,
} from '@gripp/shared-logic';
import {
  ColumnsFilterScreen,
  ColumnsFilterScreenHandle,
  SlideAction,
  useSlideLayout,
  ViewMode,
} from '@gripp/shared-ui';
import { useRef } from 'react';
import { useNavigate } from 'react-router';
import { HeaderResetButton } from '../../shared/components/headerResetButton/headerResetButton';
import { AddOnsBase } from './addOns';

export const AddOnsFilterPage = () => {
  const filterRef = useRef<ColumnsFilterScreenHandle>(null);
  const onBackButtonPressRef = useRef<(() => void) | undefined>(undefined);

  const { data: filter } = useAddOnFilter();
  const { mutateAsync: setFilter } = useSetAddOnFilter();
  const validateListOrder = useValidateAddOnListOrder();

  const rightColumn = {
    title: 'addOn.list.addOns',
    mainComponent: (
      <>
        <ColumnsFilterScreen
          ref={filterRef}
          mode="page"
          filter={filter}
          setFilter={setFilter}
          validateListOrder={validateListOrder}
          createDefaultFilter={() => new AddOnFilterModel()}
          createFilter={(data) => new AddOnFilterModel(data)}
          baseColumns={AddOnFilterColumns}
          i18nPrefix="addOn.filter"
          viewResultsTranslationKey="common.apply"
          bottomBar={() => <></>}
        />
        <BackHandlerRegistrar onBackButtonPressRef={onBackButtonPressRef} />
      </>
    ),
    headerComponent: (
      <HeaderResetButton onReset={() => filterRef.current?.onReset()} />
    ),
    showBackButton: true,
    onBackButtonPress: () => onBackButtonPressRef.current?.(),
  };

  return <AddOnsBase rightColumn={rightColumn} viewMode={ViewMode.DUAL} />;
};

const BackHandlerRegistrar = ({
  onBackButtonPressRef,
}: {
  onBackButtonPressRef: React.MutableRefObject<(() => void) | undefined>;
}) => {
  const navigate = useNavigate();
  const { onSlideChange } = useSlideLayout();

  onBackButtonPressRef.current = async () => {
    await onSlideChange(SlideAction.SINGLE);
    navigate('/add-ons');
  };

  return null;
};
